import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

export const pipelineRunRouter: RouteRecordRaw[] = [
  {
    component: async () =>
      await import('../components/editors/menu/MenuPipelineRun.vue'),
    name: 'pipelineRun',
    path: 'pipeline-run/:menuId/:runId',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId,
      mostRecentRunId: route.query.mostRecentRunId,
      runId: route.params.runId,
    }),
  },
  {
    component: async () =>
      await import('../components/editors/menu/MenuImprovements.vue'),
    name: 'menuImprovements',
    path: 'menu-improvements/:menuId/:reportId?',
    props: (route: RouteLocationNormalized) => ({
      menuId: route.params.menuId,
      reportId: route.params.reportId,
    }),
  },
]
